module.exports = __webpack_public_path__ + "static/media/corner.66d58303.svg";